type Props = {
    id: number;
    title: string;
    description: string;
    isLast?: boolean;
};

export default function HowItWorksStep({
    id,
    title,
    description,
    isLast = false,
}: Props) {
    return (
        <div
            className={`relative flex items-start gap-3 ${!isLast ? "mb-4" : ""
                }`}
        >
            {/* Number */}
            <div className="relative z-10 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-[#8ED5BC] bg-[#EAF8F2] text-[15px] font-semibold text-[#17815F]">
                {id}
            </div>

            {/* Content */}
            <div className="flex-1">
                <h3 className="text-[15px] font-semibold leading-5 text-[#17231E]">
                    {title}
                </h3>

                <p className="mt-2 text-[13px] leading-6 text-[#70817B]">
                    {description}
                </p>
            </div>
        </div>
    );
}